import { z, ZodType } from "zod"

export type OrgAdminCreateAccountFormValues = {
  email: string
  password: string
  passwordConfirmation: string
  name: string
}

export const orgAdminCreateAccountSchema: ZodType<OrgAdminCreateAccountFormValues> =
  z
    .object({
      email: z
        .string()
        .min(1, "Email address is required")
        .email({ message: "Email address is invalid" }),
      password: z
        .string()
        .min(8, "A password of at least 8 characters is required"),
      passwordConfirmation: z.string(),
      name: z.string(),
    })
    .refine((data) => data.password === data.passwordConfirmation, {
      message: "Passwords do not match",
      path: ["passwordConfirmation"],
    })
